/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
==========================================================================================*/

export default [
  {
    url: '/home',
    name: 'dashboard.title',
    slug: 'home',
    icon: 'ActivityIcon'
  },
  {
    url: null,
    header: 'sidebar.groups.workouts',
    permissions: ['read category workouts'],
    items: [
      {
        url: '/workouts/categories',
        name: 'category_workouts.title',
        slug: 'workouts-categories',
        icon: 'ListIcon',
        permissions: ['read category workouts']
      },
      {
        url: '/workouts',
        name: 'workouts.title',
        slug: 'workouts-categories',
        icon: 'CheckCircleIcon',
        permissions: ['read workouts']
      }
    ]
  },
  {
    url: null,
    header: 'sidebar.groups.routines_templates',
    permissions: ['read category routines_templates'],
    items: [
      {
        url: '/routines/categories',
        name: 'category_routines_templates.title',
        slug: 'routines-categories',
        icon: 'ListIcon',
        permissions: ['read category routines_templates']
      },
      {
        url: '/routines',
        name: 'routines_templates.title',
        slug: 'routines-categories',
        icon: 'CheckCircleIcon',
        permissions: ['read routines_templates']
      },
      {
        url: '/programs',
        name: 'programs.title',
        slug: 'programs',
        icon: 'TargetIcon',
        permissions: ['read programs']
      }
    ]
  },
  {
    url: null,
    header: 'sidebar.groups.subscriptions',
    permissions: ['read clients'],
    items: [
      {
        url: '/clients',
        name: 'clients.title',
        slug: 'clients',
        icon: 'UserIcon',
        permissions: ['read clients']
      },
      {
        url: '/newForms',
        name: 'order.news.title',
        slug: 'formularios-nuevos',
        icon: 'FileTextIcon',
        permissions: ['read orders']
      },
      {
        url: '/renewalForms',
        name: 'order.olds.title',
        slug: 'formularios-nuevos',
        icon: 'FileTextIcon',
        permissions: ['read orders']
      }
    ]
  },
  {
    url: null,
    header: 'sidebar.groups.miscellaneous',
    permissions: ['read videos', 'read faqs', 'read coupons', 'read availabilities'],
    items: [
      {
        url: '/videos',
        name: 'videos.title',
        slug: 'videos',
        icon: 'ImageIcon',
        permissions: ['read videos']
      },
      {
        url: '/coupons',
        name: 'coupons.title',
        slug: 'coupons',
        icon: 'PercentIcon',
        permissions: ['read coupons']
      },
      {
        url: '/faqs',
        name: 'faqs.title',
        slug: 'faqs',
        icon: 'BookmarkIcon',
        permissions: ['read faqs']
      },
      {
        url: '/availabilities',
        name: 'availabilities.title',
        slug: 'availabilities',
        icon: 'CheckCircleIcon',
        permissions: ['read availabilities']
      }
    ]
  },
  {
    url: null,
    header: 'sidebar.groups.security',
    permissions: ['read users', 'read role', 'read products'],
    items: [
      {
        url: '/users',
        name: 'users.title',
        slug: 'users',
        icon: 'UsersIcon',
        permissions: [
          'read users',
          'create users',
          'edit users',
          'delete users',
          'assign_permissions users'
        ]
      },
      {
        url: '/role',
        name: 'roles.title',
        slug: 'role',
        icon: 'ShieldIcon',
        permissions: [
          'read role',
          'create role',
          'edit role',
          'delete role'
        ]
      },
      {
        url: '/prices',
        name: 'products.title',
        slug: 'prices',
        icon: 'CreditCardIcon',
        permissions: [
          'read products',
          'edit products'
        ]
      }
    ]
  }
]
